/*
 * Chat backend adresi.
 *
 * Varsayılan olarak her zaman yayındaki FastAPI'ye gider (kendi VPS'imiz,
 * deploy/deploy.sh ile güncellenir; eski Render adresi: onur-cv-ai.onrender.com)
 * — böylece siteyi
 * localhost'ta açtığında da soru-cevap çalışır.
 *
 * Backend'i kendi makinende çalıştırıyorsan (uvicorn main:app --reload),
 * frontend/.env.local dosyası oluşturup şunu yaz:
 *
 *   REACT_APP_API_URL=http://127.0.0.1:8000
 *
 * ve `npm start`'ı yeniden başlat.
 */

export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.onurcinkaya.cv";
